import React from "react";
import style from "./Explanation.module.css";
import Icon from "@/ui/icon/Icon";
import Button from "@/ui/button/Button";

import "katex/dist/katex.min.css";
import Latex from "react-latex-next";

function Explanation({ explanation, onCloseModal }) {
	if (!explanation) return null;

	// Check if the explanation contains LaTeX by looking for common LaTeX patterns
	const hasLatex =
		/(\$\$|\$|\\[a-zA-Z]+|\{|\}|\\frac|\\sqrt|\\sum|\\int)/.test(
			explanation
		);

	// Process the explanation to handle newline indicators
	const processExplanation = (text) => {
		// Replace literal \n with actual newlines
		const withNewlines = text.replace(/\\n/g, "\n");

		// Split by newlines and create paragraphs
		const lines = withNewlines
			.split("\n")
			.filter((line) => line.trim() !== "");

		return lines;
	};

	const explanationLines = processExplanation(explanation);

	return (
		<div className={style.explanation}>
			<div className={style.header}>
				<div className={style.titleSection}>
					<div className={style.iconHolder}>
						<Icon icon="fa-lightbulb" />
					</div>
					<h5>Objašnjenje</h5>
				</div>
				<button className={style.closeButton} onClick={onCloseModal}>
					<Icon icon="fa-times" />
				</button>
			</div>
			<div className={style.content}>
				{hasLatex
					? explanationLines.map((line, index) => (
							<div key={index} style={{ marginBottom: "0.5rem" }}>
								<Latex>{line}</Latex>
							</div>
						))
					: explanationLines.map((line, index) => (
							<p key={index}>{line}</p>
						))}
			</div>
		</div>
	);
}

export default Explanation;
